const normalizeApiError = (error, options = {}) => {
  const {
    context = '',
    fallbackMessage = 'No pudimos procesar tu solicitud. Intentá nuevamente.',
    logger = console
  } = options;

  if (context && logger?.error) {
    logger.error(`Error ${context}`, error);
  } else if (logger?.error) {
    logger.error('API request error', error);
  }

  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallbackMessage;

  return {
    success: false,
    data: null,
    error: message
  };
};

export default normalizeApiError;
